import { Site } from '@envato/foundation-types'
import * as classnames from 'classnames'
import keys from 'lodash-es/keys'
import * as React from 'react'

import useToggle from '../../../common/hooks/useToggle'
import quickLinksConfig from '../../../config/layout/quickLinks'
import TextLink from '../textLink'
import SiteLinks from './siteLinks'
import ga from '../../../common/utils/ga'

import * as styles from './quickLinksFooter.module.css'

interface IProps {
  currentSite: Site
}

const QuickLinksFooter = ({ currentSite }: IProps) => {
  if (currentSite == Site.themeforest || currentSite == Site.codecanyon) {
    const sites = keys(quickLinksConfig) as (keyof typeof quickLinksConfig)[]
    const [collapsed, toggle] = useToggle(false)
    const toggleClassNames = classnames(styles.toggleIcon, {
      [styles.toggleIconPlus]: collapsed
    })
    const contentClassNames = classnames(styles.content, {
      [styles.contentHidden]: collapsed
    })
    const handleToggle = (event: React.MouseEvent | React.TouchEvent) => {
      toggle()
      const eventAction = collapsed ? 'click;expand' : 'click;collapse'
      ga('send', {
        hitType: 'event',
        eventCategory: 'footer quicklinks',
        eventAction: eventAction,
        eventLabel: 'quick links'
      })
    }

    return (
      <div className={styles.quicklinks} role="navigation">
        <div className={styles.gridWide}>
          <div className={styles.container}>
            <div className={styles.title}>
              <div
                className={styles.toggle}
                onClick={handleToggle}
                role="button"
              >
                <i className={toggleClassNames} />
                <TextLink className={styles.toggleText}>Quick Links</TextLink>
                <span className={styles.toggleSubText}>
                  Explore popular categories
                </span>
              </div>
            </div>
            <div className={contentClassNames}>
              {sites.map((site, index) => (
                <SiteLinks currentSite={currentSite} site={site} key={index} />
              ))}
            </div>
          </div>
        </div>
      </div>
    )
  } else {
    return null
  }
}

export default QuickLinksFooter
